import { Ref, ref } from 'vue';
import { InformeService } from '@/services/InformeService';

const atencionCount: Ref<number> = ref(0);
let pollingInterval: number | null = null;

export function useInformesAtencion() {
  const fetchAtencionCount = async () => {
    try {
      atencionCount.value = await InformeService.atencionCount();
    } catch (error) {
      console.error('Error fetching informes atencion count:', error);
      atencionCount.value = 0;
    }
  };

  const startPolling = (interval = 60000) => {
    fetchAtencionCount();
    if (!pollingInterval) {
      pollingInterval = window.setInterval(fetchAtencionCount, interval);
    }
  };

  const stopPolling = () => {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  };

  return {
    atencionCount,
    fetchAtencionCount,
    startPolling,
    stopPolling,
  };
}
